module.exports = __webpack_public_path__ + "img/arrow-right-square-fill.974b1c32.svg";